// extracted by mini-css-extract-plugin
export default {"email":"contacts-module___email___d4b1d42b","contact":"contacts-module___contact___bbfe08d3"};